module.exports = __webpack_public_path__ + "img/详细解决方案_01.a08c213a.svg";